<template>
    <el-button :type="type" size="mini" @click="exportData"> 导出数据 </el-button>
</template>
<script>
export default {
    name: "ExportButton",
    props: {
        url: { type: String, required: true },
        param: { type: Object },
        type: { type: String, default: "primary" },
    },
    methods: {
        exportData() {
            this.$ajax.post(this.url, this.param).then((result) => {
                var data = result.Data;
                // for (let key in this.$lang.titles.excels) {
                //   let k = "[Column-" + key + "]";
                //   while (data.indexOf(k) >= 0) {
                //     data = data.replace(k, this.$lang.titles.excels[key]);
                //   }
                // }
                // for (let key in this.$lang.titles.excelData) {
                //   let k = "[Data-" + key + "]";
                //   while (data.indexOf(k) >= 0) {
                //     data = data.replace(k, this.$lang.titles.excelData[key]);
                //   }
                // }
                let blob = new Blob(["\ufeff" + data], {
                    type: "text/csv,charset=UTF-8",
                });
                let url = URL.createObjectURL(blob);
                var a = document.createElement("a");
                a.setAttribute("href", url);
                a.setAttribute("download", "data.csv");
                a.setAttribute("target", "_blank");
                let clickEvent = document.createEvent("MouseEvents");
                clickEvent.initEvent("click", true, true);
                a.dispatchEvent(clickEvent);
            });
        },
    },
};
</script>
